import { t } from 'i18next'
import { Card } from 'primereact/card'
import { Chart } from 'primereact/chart'
import React, { useEffect, useState } from 'react'
import { ProfessionCt, SalutationCt } from '../../../../model/enums/enums'
import { Apprentice } from '../../../../model/person.model'
import { useAppSelector } from '../../../../redux/hooks'

interface GenderProfessionDataSet {
  idProfession: number
  femaleCount: number
  maleCount: number
  diverseCount: number
  notSetCount: number
  totalCount: number
}

export const ApprenticeGenderStatisticByProfession = () => {
  const apprentices = useAppSelector((state) => state.apprentices)
  const professions = useAppSelector((state) => state.professions)

  const [sets, setSets] = useState<GenderProfessionDataSet[]>([])
  const [totalApprenticesWithProf, setTotalApprenticesWIthProf] =
    useState<number>(0)

  useEffect(() => {
    if (professions.length <= 0 || apprentices.length <= 0) {
      return
    }

    const dataSets: GenderProfessionDataSet[] = []

    const apprenticesWithProfession = apprentices.filter(
      (x: Apprentice) => x.apprentice?.id_profession
    )
    const usedProfessions: (ProfessionCt | undefined)[] =
      apprenticesWithProfession.map((a) => {
        if (a.apprentice?.id_profession) {
          return a.apprentice.id_profession
        }
      })

    const distinctProfIds = new Set(usedProfessions)

    distinctProfIds.forEach((id) => {
      if (id) {
        const appsWithProfession = apprentices.filter(
          (a) => a.apprentice?.id_profession === id
        )
        const dataSet: GenderProfessionDataSet = {
          idProfession: id,
          diverseCount: appsWithProfession.filter(
            (a) => a.salutation === SalutationCt.Diverse
          ).length,
          femaleCount: appsWithProfession.filter(
            (a) => a.salutation === SalutationCt.Ms
          ).length,
          maleCount: appsWithProfession.filter(
            (a) => a.salutation === SalutationCt.Mr
          ).length,
          notSetCount: appsWithProfession.filter(
            (a) => a.salutation === SalutationCt.NoSpecification
          ).length,
          totalCount: appsWithProfession.length,
        }
        dataSets.push(dataSet)
      }
    })

    setSets(dataSets)
    const countApps = dataSets.reduce((accumulator, obj) => {
      return accumulator + obj?.totalCount
    }, 0)
    setTotalApprenticesWIthProf(countApps)
  }, [apprentices, professions])

  const chartOptions = {
    plugins: {
      legend: {
        title: { display: false },
        display: false,
      },
    },
  }

  const activeLanguage = localStorage.getItem('i18nextLng')

  const translateProf = (profId: number) => {
    const prof = professions.find((p) => p.profession_id === profId)
    if (prof) {
      return activeLanguage !== 'de'
        ? t(`profession.${prof.profession_id}`)
        : prof.profession
    }
    return '?'
  }

  return (
    <>
      {sets.length < 1 ? (
        <></>
      ) : (
        <div className={'col-6 card-hover'}>
          <h5 className={'pb-0 mb-2 statistic-text'}>
            {t('core.statistic.count_apprentices_gender_by_prof')} (
            {totalApprenticesWithProf})
          </h5>
          <div
            className={
              'w-full grid flex-wrap gap-1 justify-content-end align-items-end '
            }
          >
            {sets.map((set: GenderProfessionDataSet) => {
              return (
                <Card
                  className={
                    'col grid m-2 justify-content-center align-items-center card-hover'
                  }
                  key={set.idProfession + '_profKey'}
                >
                  <h5 className={'small-text col-12 w-full statistic-text'}>
                    {translateProf(set.idProfession)}{' '}
                    <span className={''}>({set.totalCount})</span>
                  </h5>
                  <div
                    className={
                      'col-12 flex justify-content-center align-items-center'
                    }
                  >
                    <Chart
                      className={''}
                      width={'100px'}
                      height={'100px'}
                      options={chartOptions}
                      type={'doughnut'}
                      data={{
                        labels: [
                          t<string>('core.statistic.women'),
                          t<string>('core.statistic.men'),
                          t<string>('core.statistic.diverse'),
                          t<string>('core.statistic.not_specified'),
                        ],
                        datasets: [
                          {
                            data: [
                              set.femaleCount,
                              set.maleCount,
                              set.diverseCount,
                              set.notSetCount,
                            ],
                            backgroundColor: [
                              '#E0979E',
                              'rgb(0, 127, 192)',
                              '#8d7a70',
                              'rgb(135, 136, 138)',
                            ],
                            hoverBackgroundColor: [
                              '#ffa7b0',
                              'rgb(0,163,248)',
                              '#d5b7a7',
                              'rgb(204,204,204)',
                            ],
                          },
                        ],
                      }}
                    />
                  </div>
                </Card>
              )
            })}
          </div>
        </div>
      )}
    </>
  )
}